import { Link as MUILink } from "@mui/material";
import Template from "models/template";
import React from "react";
import SolrService from "services/SolrService";

const { inputService } = new SolrService();

export default function MetadataModelTemplate({
  input_id,
  template,
}: {
  input_id: string;
  template: Template;
}) {
  const downloadFile = async () => {
    const blob = await inputService.template(input_id, template.guid);
    if (blob) {
      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = template.name;
      link.click();
    }
  };
  return (
    <MUILink
      onClick={downloadFile}
      component="a"
      underline="hover"
      sx={{
        cursor: "pointer",
        wordWrap: "break-word",
        color: ["nrdata-orig"].includes(
          process.env.REACT_APP_STYLING_THEME ?? "",
        )
          ? "#06c"
          : undefined,
      }}
    >
      {template.name}
    </MUILink>
  );
}
